import { render, staticRenderFns } from "./merchantImport.vue?vue&type=template&id=8c724c36&"
import script from "./merchantImport.vue?vue&type=script&lang=js&"
export * from "./merchantImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\项目管理\\旧换新\\源码\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c724c36')) {
      api.createRecord('8c724c36', component.options)
    } else {
      api.reload('8c724c36', component.options)
    }
    module.hot.accept("./merchantImport.vue?vue&type=template&id=8c724c36&", function () {
      api.rerender('8c724c36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/merchantImport/merchantImport.vue"
export default component.exports